import { useQuery } from "react-query";

import { staticDropdownValuesService } from "services";

export const useMonthsQueryForHookForm = () =>
	useQuery("months", staticDropdownValuesService.getMonthsForHookForm);

export default useMonthsQueryForHookForm;
